export default __webpack_public_path__ + "static/media/score_star.0706f842.png";